export function promisify(subject, manifest) {
  if (subject instanceof Promise) {
    return subject
  }

  return new Promise((resolve, reject) => {
    if (typeof subject !== 'function') {
      resolve(subject)
    } else {
      try {
        resolve(subject.call(void 0, manifest))
      } catch (error) {
        reject({ error, manifest })
      }
    }
  })
}
